const state = {
  users: [],
  user: {},
  loading: false,
  error: null,
  hasError: false,
};

export default state;
